<template>
  <footer class="homefooter">
    <div class="contract-info">
      <div class="item">
        <h3 class="footer-item-title">联系美团&nbsp;&amp;&nbsp;电话验证</h3>
        <span class="footer-item-content">400-660-1065</span>
        <span class="extra">周一到周日&nbsp;09:00-21:00</span>
      </div>
      <div class="item" v-if="defaultBd.name">
        <h3 class="footer-item-title">联系BD：{{defaultBd.name}}</h3>
        <span class="footer-item-content">{{defaultBd.phone}}</span>
        <a class="other-bds" @click.stop.prevent="moreBds" href="javascript:void(0)">联系其他BD
          <Icon type="turbo-ui-arrow-right" />
        </a>
      </div>
      <Modal v-model="bdModal" width="600">
        <p slot="header">
          联系BD
        </p>
        <ul>
          <li v-for="bd in bds" :key="bd.phone" class="bd-info-item">
            <span class="bd-info-name">姓名：{{bd.name}}</span>
            <span class="bd-info-phone">联系电话：{{bd.phone}}</span>
            <span class="bd-info-email">联系邮箱：
              <a :href="'mailto:'+bd.email">{{bd.email}}</a>
            </span>
          </li>
        </ul>
        <div slot="footer">
          <Button type="primary" @click="closeBdModal">关闭</Button>
        </div>
      </Modal>
      <div class="item">
        <h3 class="footer-item-title">反馈&nbsp;&amp;&nbsp;投诉</h3>
        <a href="mailto:lianzheng@meituan.com" class="footer-item-content mail">lianzheng@meituan.com</a>
        <span class="extra">周一到周日&nbsp;09:00-21:00</span>
      </div>
      <div class="item qr-code-wrapper">
        <div class="qrcode">
          <img class="qr-code" src="//p0.meituan.net/codeman/3cb78560876cc53cb80c37d0229fe90c6357.png" />
          <div class="footer-item-content">
            <h2>美团旅行商家App</h2>
            <span>扫描二维码下载</span>
          </div>
        </div>
      </div>
    </div>
    <div class="logo">
      <p>
        <a href="//www.meituan.com/" target="_blank">©美团网团购meituan.com</a>
        <a href="http://www.miitbeian.gov.cn/" target="_blank">京ICP证070791号京ICP备10211739号 </a>
      </p>
    </div>
  </footer>
</template>
<script>
  import { mapActions } from "vuex";
  import { getBdsInfo } from "api/ticket";
  import { formatPhone } from "utils/notices";
  export default {
      data: function() {
          return {
              defaultBd: {
                  name: null,
                  phone: null
              },
              bds: [],
              bdModal: false
          };
      },
      created() {
          this.getUser().then(bizUser => {
              if (bizUser) {
                  getBdsInfo(bizUser.supplierId).then(bds => {
                      if (bds && bds.length) {
                          let defaultBd = bds[0];
                          this.defaultBd.name = defaultBd.bdName;
                          this.defaultBd.phone = formatPhone(defaultBd.bdTelephone);
                          this.bds = bds.map(bd => {
                              return {
                                  name: bd.bdName,
                                  phone: formatPhone(bd.bdTelephone),
                                  email: bd.bdOwnEmail
                              };
                          });
                      }
                  });
              }
          });
      },
      methods: {
          ...mapActions(["getUser"]),
          moreBds() {
              if (!this.bds || !this.bds.length) {
                  this.$Notice.info({
                      title: "暂无更多BD"
                  });
              } else {
                  this.bdModal = true;
              }
          },
          closeBdModal() {
              this.bdModal = false;
          }
      }
  };
</script>
<style lang="postcss" scoped>
.bd-info-item {
  display: flex;
  padding-bottom: 10px;
  font-size: 14px;
  &:last-child {
    padding-bottom: 0;
  }
  & .bd-info-name {
    flex: 0 0 8em;
  }
  & .bd-info-phone {
    flex: 0 0 13em;
  }
  & .bd-info-email {
    flex: 1 1 50px;
  }
}
.homefooter {
  padding: 0 20px 20px 20px;
  display: flex;
  flex-direction: column;
  .logo {
    transform: scale(0.91);
    margin-top: 20px;
    text-align: center;
    font-size: 12px;
    line-height: 16px;
    a {
      letter-spacing: 0.5px;
      color: #93999f;
      &:hover,
      &:focus {
        color: #37a6fc;
        text-decoration: none;
      }
    }
  }
  .contract-info {
    display: flex;
    justify-content: center;
    align-self: center;
    .item {
      &.qr-code-wrapper {
        margin-right: 0 !important;
      }
      font-weight: 300;
      flex: 0 1 auto;
      margin-right: 60px;
      .content,
      .extra {
        display: block;
      }
      .footer-item-title {
        font-size: 12px;
        color: #333d48;
        font-weight: 300;
      }
      .footer-item-content {
        display: block;
        margin: 3px 0 2px 0;
        font-size: 18px;
        color: #333d48;
        &.mail {
          color: ##333d48;
          &:hover,
          &:focus {
            color: #37a6fc;
            text-decoration: none;
          }
        }
      }
      .extra {
        font-size: 12px;
        color: #60666e;
      }
      .other-bds {
        font-size: 12px;
        color: #60666e;
        &:hover,
        &:focus {
          color: #37a6fc;
          text-decoration: none;
        }
      }
      .qr-code {
        height: 71px;
        display: block;
        margin-right: 15px;
      }
      .qrcode {
        display: flex;
        align-items: center;
        .footer-item-content {
          display: block;
          & > h2 {
            font-size: 18px;
            color: #333d48;
            font-weight: 300;
            line-height: 25px;
          }
          & > span {
            display: block;
            font-size: 12px;
            color: #333d48;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Footer.vue?cadaf760